import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "../../../../Components/CSS/FilterStyle.css";

class StaffFilter extends Component {
  render() {
    const { classes, data, handleSearch } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.title}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="employeeName"
            type="text"
            label="Employee Name"
            variant="outlined"
            margin="normal"
            placeholder="Search by employee's name"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.employeeName}
            onChange={handleSearch}
          />
          <TextField
            name="department"
            select
            label="Department"
            variant="outlined"
            margin="normal"
            placeholder="Search by department"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.department}
            onChange={handleSearch}
          >
            <option value="">Select Any One</option>
            <option value="Administration">Administrative Staff</option>
            <option value="Teaching">Teaching Staff</option>
            <option value="Non-Teaching">Non-Teaching Staff</option>
          </TextField>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(StaffFilter);
